/**
 * Modal shell around HubSpot's official form embeds.
 *
 * HubSpot owns everything inside the panels: fields, validation, submission,
 * the success message and the follow-up email. This file only opens and closes
 * the modal, swaps between the contact and download panels, and manages focus.
 */
class IgridLeadForm extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('.igrid-lead__dialog');
    this.panels = this.querySelectorAll('[data-lead-panel]');

    this.querySelectorAll('[data-lead-dismiss]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  get isConfigured() {
    return Boolean(this.dataset.formId);
  }

  open(intent, trigger) {
    // Falls back to the contact panel, which always exists. The download panel
    // is only rendered when a separate download form is configured.
    const panel = this.querySelector(`[data-lead-panel="${intent}"]`) || this.panels[0];

    this.trigger = trigger;
    this.panels.forEach((el) => {
      el.hidden = el !== panel;
    });

    const heading = panel.querySelector('.igrid-lead__title');
    if (heading) this.dialog.setAttribute('aria-labelledby', heading.id);

    this.hidden = false;
    document.body.classList.add('overflow-hidden');

    // The forms render while the modal is display:none, so an embed that sized
    // itself against a zero-height box has no reason to measure again on its
    // own. A resize event after the modal is visible gives it that reason.
    window.dispatchEvent(new Event('resize'));

    trapFocus(this.dialog, heading);
  }

  close() {
    if (this.hidden) return;
    this.hidden = true;
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(this.trigger);
  }
}

customElements.define('igrid-lead-form', IgridLeadForm);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-lead-open]');
  if (!trigger) return;

  // A trigger can name its modal, but it does not have to. The hero buttons sit
  // in a section that knows nothing about the CTA section further down the page,
  // so rather than hardcoding that section's generated ID into another section,
  // an unnamed trigger falls back to the page's first lead form. There is only
  // ever one on a page.
  const modal =
    (trigger.dataset.leadTarget && document.getElementById(trigger.dataset.leadTarget)) ||
    document.querySelector('igrid-lead-form');

  // Without a HubSpot form ID there is nothing to open, so the trigger is left
  // as whatever plain link the section settings gave it.
  if (!modal || !modal.isConfigured) return;

  event.preventDefault();
  modal.open(trigger.dataset.leadOpen, trigger);
});
